import { createContext } from 'react'

type ResetKey = () => void

export const ResetNativeAppContext = createContext<ResetKey>(() => {
  //
})
